.row {
	display: flex;
	align-items: flex-start;
	gap: 6px;
	padding: 4px 0;
}

.field {
	min-width: 0;
}

.removeButton {
	flex-shrink: 0;
	background: none;
	border: none;
	cursor: pointer;
	color: #ef4444;
	padding: 6px 4px;
	display: flex;
	align-items: center;
	border-radius: 4px;
	margin-top: 2px;
	transition: background 0.15s;

	&:hover {
		background: #fef2f2;
	}
}

.rowReadOnly {
	opacity: 0.7;
	background: #f9fafb;
	border-radius: 4px;
	padding: 4px 6px;
}
